import { DeliveriesLabels } from "../financial.types";

/** ChapShop's own point of view. */
export const ADMIN_DELIVERIES_LABELS: DeliveriesLabels = {
  toCollect: "To collect",
  toPay: "To pay",
  paid: "Paid",
  collected: "Collected"
};

/** The same amounts as seen by a delivery company. */
export const COMPANY_DELIVERIES_LABELS: DeliveriesLabels = {
  toCollect: "To reverse",
  toPay: "To recover",
  paid: "Recovered",
  collected: "Reversed"
};
